import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaArrowLeft, FaArrowRight, FaListAlt, FaVideo } from "react-icons/fa";
import { MdAccessTime, MdArrowLeft, MdArrowRight, MdArrowRightAlt, MdDelete, MdModeEdit, MdPlayArrow, MdScreenShare, MdVideoLibrary } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";

const VIDEO_AI_EVENT_LABELS = {
    AI_ASSISTANT: "Assistente de IA",
    BOOK: "Livro",
    BROWSER_NEW_TAB: "Nova aba do navegador",
    CALCULATOR: "Calculadora",
    CELL_PHONE: "Celular",
    EARBUDS: "Fones intra-auriculares",
    EMAIL: "E-mail",
    EXTERNAL_WEBSITE: "Site externo",
    HEADPHONES: "Fones de ouvido",
    LAPTOP: "Notebook",
    LONG_HAIR: "Cabelo longo",
    LOOKING_AWAY: "Olhar desviado",
    MESSAGING: "Mensagens",
    MULTIPLE_FACES: "Múltiplos rostos",
    MULTIPLE_PEOPLE: "Múltiplas pessoas",
    MULTIPLE_SPEAKERS: "Múltiplas vozes",
    NO_FACE: "Sem pessoas",
    NO_PERSON: "Sem pessoas",
    PAPER: "Papel",
    PERSON: "Pessoa",
    REFERENCE: "Referência",
    SEARCH_ENGINE: "Buscador",
    SECOND_SPEAKER: "Segunda voz",
    SPEECH: "Fala detectada",
    START_MENU: "Menu iniciar",
    SMARTWATCH: "Relógio inteligente",
    TV_MONITOR: "TV/Monitor",
    UNKNOWN: "Evento não classificado",
};

const getVideoAIEventLabel = eventType => VIDEO_AI_EVENT_LABELS[eventType] || String(eventType || "").replace(/_/g, " ");

const TRUST_METRICS = [
    { key: "acoes_relatadas", label: "Ações reportadas", valueLabel: trust => parseInt(trust.acoes_relatadas || 0), points: trust => Number(trust.acoes_relatadas || 0) },
    { key: "average_face", label: "Média do reconhecimento facial", valueLabel: trust => `${parseFloat(100 - (trust.average_face || 0)).toFixed(2)}%`, points: trust => Number(trust.average_face || 0) },
    { key: "face_validaiton_again", label: "Validações faciais periódicas", valueLabel: trust => trust.face_validaiton_again || 0, points: trust => Number(trust.face_validaiton_again || 0) },
    { key: "no_face", label: "Fotos sem rosto detectado", valueLabel: trust => trust.no_face || 0, points: trust => Number(trust.no_face || 0) },
    { key: "request_validation", label: "Pedidos de liberação para o fiscal", valueLabel: trust => trust.request_validation || 0, points: trust => Number(trust.request_validation || 0) },
    { key: "saidas", label: "Saídas de tela", valueLabel: trust => trust.saidas || 0, points: trust => Number(trust.saidas || 0) },
    { key: "tempo", label: "Tempo de saída da tela de prova", valueLabel: trust => `${trust.tempo || 0} segundos`, points: trust => Number(trust.tempo || 0) },
    { key: "video_no_face", label: "Vídeos sem rosto", valueLabel: trust => parseFloat(trust.video_analyse?.no_face || 0).toFixed(2), points: trust => Number(trust.video_analyse?.no_face || 0) },
    { key: "video_multiple_faces", label: "Múltiplos rostos nos vídeos", valueLabel: trust => parseFloat(trust.video_analyse?.multiple_faces_detected || 0).toFixed(2), points: trust => Number(trust.video_analyse?.multiple_faces_detected || 0) },
    { key: "ip_equal", label: "IPs idênticos", valueLabel: trust => trust.ip_equal || 0, points: trust => Number(trust.ip_equal || 0) },
];



const Relatorio = props => {

    const [lesson_cards, SetLessonCards] = useState(null);
    const [loading_screen, setLoadingScreen] = useState(true);
    const [loading_relatorio, setLoadingrelatorio] = useState(false);
    const [search_oficial, setSearchOficial] = useState('');

    const [logs, setlogs] = useState([]);
    const [deixou_aplicacao, setDeixouAplicacao] = useState(0);
    const [logs_saidas, setLogsSaidas] = useState([]);
    const [logs_warning, setLogsWarning] = useState([]);

    const [acoes_relatadas, setAcoesRelatadas] = useState([]);

    const [loading_allow,setLoadingAllow] = useState(false);
    const [show_btn_allow,setShowBtnAllow] = useState(false);



    const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });


    const [current_page, setCurrentPage] = useState(1);
    const [last_page, setLastPage] = useState(1);

    const [search, setSearch] = useState('');
    const { candidato_id, candidato_name, processo_id,trust,trust_points } = props;
    const [show_warning, setShowWarning] = useState(false);
    const [relatorio_id, setrelatorioId] = useState(null);
    const [selectedAIEvents, setSelectedAIEvents] = useState({});
    const [selectedTrustMetrics, setSelectedTrustMetrics] = useState({});


    const [questaoSelect, setQuestaoSelect] = useState({});

    const [showModal, setShowModal] = useState(false);
    let refs = [];
    const dispatch = useDispatch();

    const Getrelatorio = async (page, search) => {

        let response = await Request.Get(`faculdade/show_relatorio_aluno/${processo_id}/${candidato_id}?page=${page}&search=${search}`);
        console.log(response);
        if (response === undefined) return;
        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }

            setlogs(response.logs);
            setLogsSaidas(response.logs_saidas);
            setLogsWarning(response.logs_warning);

            setDeixouAplicacao(response.deixou_aplicacao);

            setAcoesRelatadas(response.acoes_relatadas);
            // setShowBtnAllow(response.show_btn_access);


         

            // setPagination({...response.pagination});

            setLoadingScreen(false);
            setLoadingrelatorio(false);


    }

    const [relatorio_select, setVideoSelect] = useState(null);

    const Deleterelatorio = async (relatorio_id) => {

        let response = await Request.Delete(`faculdade/delete_relatorio/${relatorio_id}`);
        console.log(response);
        if (response === undefined) return;

        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        Getrelatorio(current_page, search_oficial);



    }

    const AccessLiberation = async () => {

        let response = await Request.Get(`faculdade/allow_access/${processo_id}/${candidato_id}`);
        console.log(response);
        setLoadingAllow(false);

        if (response === undefined) return;
        if (response.message == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        // else if(response['status']==undefined){
        //     setLoadingZip(false);

        //     saveAs(response,'provas_processo_'+processo_name+'.zip');
        // }
        else {
            setLoadingScreen(true);

            Getrelatorio(1, search_oficial);
            
            // saveAs(response, 'analises_candidatos_' + processo_name + '.xlsx');


        }
    }

    useEffect(() => {
        Getrelatorio(1, search_oficial);
    }, []);

    useEffect(() => {
        const details = trust?.video_ai_event_details || {};
        const selected = {};
        Object.keys(details).forEach(eventType => {
            selected[eventType] = details[eventType].enabled !== false;
        });
        setSelectedAIEvents(selected);

        const selectedMetrics = {};
        TRUST_METRICS.forEach(metric => {
            selectedMetrics[metric.key] = true;
        });
        setSelectedTrustMetrics(selectedMetrics);
    }, [trust]);

    const getTrustMetricRows = () => {
        if (!trust) {
            return [];
        }

        return TRUST_METRICS.map(metric => ({
            ...metric,
            value: metric.valueLabel(trust),
            points: metric.points(trust),
            selected: selectedTrustMetrics[metric.key] !== false,
        }));
    };

    const getVideoAIEventRows = () => {
        const details = trust?.video_ai_event_details || {};
        return Object.keys(details).map(eventType => ({
            eventType,
            label: getVideoAIEventLabel(eventType),
            total: details[eventType]?.total || 0,
            points: Number(details[eventType]?.points || 0),
            selected: selectedAIEvents[eventType] !== false,
        })).sort((a, b) => b.points - a.points);
    };

    const getSelectedAIPoints = () => getVideoAIEventRows().reduce((total, item) => item.selected ? total + item.points : total, 0);

    const getSelectedAIEventsCount = () => getVideoAIEventRows().reduce((total, item) => item.selected ? total + item.total : total, 0);

    const getSelectedMetricPoints = () => getTrustMetricRows().reduce((total, item) => item.selected ? total + item.points : total, 0);

    const getRecalculatedTrustPoints = () => {
        const aiPoints = getVideoAIEventRows().length > 0 ? getSelectedAIPoints() : Number(trust?.video_ai_points || 0);
        return getSelectedMetricPoints() + aiPoints;
    };

    const toggleTrustMetric = metricKey => {
        setSelectedTrustMetrics(current => ({
            ...current,
            [metricKey]: current[metricKey] === false,
        }));
    };

    const toggleAIEvent = eventType => {
        setSelectedAIEvents(current => ({
            ...current,
            [eventType]: current[eventType] === false,
        }));
    };

    let pesquisarTimeout = null;
    const history = useHistory();
    return (
        <div className="row">

            <div className="col-12">


                {/* <hr /> */}
                {loading_screen == false && <div>
                    <p className="text-muted">Aqui fica o relatorio do candidato "{candidato_name}"</p>
                   
                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}
                    {<div className="d-flex mt-2" style={{
                            flexBasis: '50%',
                            height: 'max-content',
                            justifyContent: 'flex-end'
                        }}>
                            {<div onClick={() => {
                                if (loading_allow == false) {
                                    setShowWarning(true);
                                }
                                else {

                                }
                            }} style={{ textDecoration: "none", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {loading_allow == false && <Button variant="success" className="flex align-center jcc me-2"><MdAccessTime style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Liberar/Resetar acesso do candidato</p></Button>}
                                {loading_allow == true && <div className="me-2" style={{ paddingLeft: 10, paddingRight: 10 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    <CircularProgress size={15} />
                                </div>
                                </div>}
                            </div>}


                        </div>}
                    <div className=" mb-4 mt-4">
                    <p className="mt-0 header-title" style={{  color: 'black',marginBottom:0,fontSize: '1.1rem' }}>Logs do sistema:</p>
                    </div>

                    <div className="table-rep-plugin">
                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>Ação</th>
                                        <th>De</th>
                                        <th>Até</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_relatorio == false && logs.map((item, id) => (

                                        <tr style={{  }} key={id}>
                                            <td>{item.acao}</td>
                                            <td>{item.hora_inicio}</td>
                                            <td>{item.hora_fim}</td>

                                           
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                            {loading_relatorio == true &&
                                <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                                    </div> */}
                                    <CircularProgress />
                                </div></div>

                            }
                        </div>
                    </div>
                    {loading_relatorio == false && logs.length == 0 && <div className="row w-100">
                        <div className="col-12">
                            <p style={{ textAlign: 'center' }}>Nenhum registro encontrado</p>

                        </div>
                    </div>}

                    <div className="row w-100">
                        <div className="col-12">
                            <p ><b style={{fontWeight:600}}>Saiu da página da aplicação: </b> {deixou_aplicacao}</p>
                        </div>
                    </div>


                    <div className=" mb-4 mt-4">
                        <p className="header-title" style={{  color: 'black',marginBottom:0,fontSize: '1.1rem' }}>Ações reportadas:</p>
                    </div>

                    <div className="table-rep-plugin">
                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>
                                    <th>Fiscal</th>

                                        <th>Ação</th>
                                        <th>Horário</th>
                                        <th>Ações</th>



                                    </tr>
                                </thead>
                                <tbody>
                                    {acoes_relatadas.map((item, id) => (

                                        <tr style={{  }} key={id}>
                                            <td>{item.fiscal.name}</td>
                                            <td>{item.acao}</td>
                                            <td>{moment(item.created_at).format('DD/MM/YYYY HH:mm:ss')}</td>
                                            <td>
                                                {item.video.length>0 && <a
                                                target="_blank" href={item.video[0].url}
                                                >
                                                <span
                                                    className="inline-flex align-center jcc bg-success icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Ver Vídeo da Câmera"
                                                >
                                                    <MdVideoLibrary size={17} color="white" />
                                                </span>
                                                </a>}
                                                {item.screen.length>0 && <a
                                                target="_blank" href={item.screen[0].url}
                                                >
                                                <span
                                                    className="inline-flex align-center jcc bg-info icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Ver Vídeo da Tela"
                                                >
                                                    <MdScreenShare size={17} color="white" />
                                                </span>
                                                </a>}
                                                {item.screen.length==0 && item.video.length==0 && <span>-</span>}
                                            </td>

                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                           
                        </div>
                    </div>
                    {acoes_relatadas.length == 0 && <div className="row w-100">
                        <div className="col-12">
                            <p style={{ textAlign: 'center' }}>Nenhuma ação registrada</p>

                        </div>
                    </div>}



                    

                    <div className=" mb-4 mt-4">
                        <p className="mt-0 header-title" style={{  color: 'black',marginBottom:0,fontSize: '1.1rem' }}>Registros de Saída:</p>
                    </div>

                    <div className="table-rep-plugin">
                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>Ação</th>
                                        <th>Horário</th>
                                        <th>Ações</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {logs_saidas.map((item, id) => (

                                        <tr style={{  }} key={id}>
                                            <td>{item.acao}</td>
                                            <td>{item.hora_inicio}</td>
                                            <td>
                                                {item.video.length>0 && <a
                                                target="_blank" href={item.video[0].url}
                                                >
                                                <span
                                                    className="inline-flex align-center jcc bg-success icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Ver Vídeo da Câmera"
                                                >
                                                    <MdVideoLibrary size={17} color="white" />
                                                </span>
                                                </a>}
                                                {item.screen.length>0 && <a
                                                target="_blank" href={item.screen[0].url}
                                                >
                                                <span
                                                    className="inline-flex align-center jcc bg-info icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Ver Vídeo da Tela"
                                                >
                                                    <MdScreenShare size={17} color="white" />
                                                </span>
                                                </a>}
                                                {item.screen.length==0 && item.video.length==0 && <span>-</span>}
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                           
                        </div>
                    </div>
                    {logs_saidas.length == 0 && <div className="row w-100">
                        <div className="col-12">
                            <p style={{ textAlign: 'center' }}>Nenhum registro encontrado</p>

                        </div>
                    </div>}



                    <div className=" mb-4 mt-4">
                        <p className="mt-0 header-title" style={{  color: 'black',marginBottom:0,fontSize: '1.1rem' }}>Avisos de restrição de horário/duas ou mais telas/permissões:</p>
                    </div>

                    <div className="table-rep-plugin">
                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>Ação</th>
                                        <th>Horário</th>
                                        <th>Ações</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {logs_warning.map((item, id) => (

                                        <tr style={{  }} key={id}>
                                            <td>{item.acao}</td>
                                            <td>{item.hora_inicio}</td>
                                            <td>
                                                {item.video?.length>0 && <a
                                                target="_blank" href={item.video[0].url}
                                                >
                                                <span
                                                    className="inline-flex align-center jcc bg-success icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Ver Vídeo da Câmera"
                                                >
                                                    <MdVideoLibrary size={17} color="white" />
                                                </span>
                                                </a>}
                                                {item.screen?.length>0 && <a
                                                target="_blank" href={item.screen[0].url}
                                                >
                                                <span
                                                    className="inline-flex align-center jcc bg-info icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Ver Vídeo da Tela"
                                                >
                                                    <MdScreenShare size={17} color="white" />
                                                </span>
                                                </a>}
                                                {item.screen?.length==0 && item.video?.length==0 && <span>-</span>}
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                           
                        </div>
                    </div>
                    {logs_warning.length == 0 && <div className="row w-100">
                        <div className="col-12">
                            <p style={{ textAlign: 'center' }}>Nenhum aviso encontrado</p>

                        </div>
                    </div>}


                    <div className=" mb-4 mt-4">
                        <p className="mt-0 header-title" style={{  color: 'black',marginBottom:0,fontSize: '1.1rem' }}>Confiabilidade: </p>
                    </div>

                    {trust && <div className="table-rep-plugin">
                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead><th colSpan={2}>Indices</th></thead>
                                <tbody>
                                

                                <tr >
                                    <td><b>Ações reportadas</b></td>
                                    <td>{parseInt(trust.acoes_relatadas)}</td>

                                </tr>
                                <tr >
                                    <td><b>Média do reconhecimento facial</b></td>
                                    <td>{parseFloat(100-trust.average_face).toFixed(2)}</td>

                                </tr>
                                <tr >
                                    <td><b>Validações faciais periódicas</b></td>
                                    <td>{trust.face_validaiton_again}</td>

                                </tr>
                                <tr >
                                    <td><b>Fotos sem rosto detectado</b></td>
                                    <td>{trust.no_face}</td>

                                </tr>
                                <tr >
                                    <td><b>Número de pedidos de liberação para o fiscal</b></td>
                                    <td>{trust.request_validation}</td>

                                </tr>
                                <tr >
                                    <td><b>Saídas de tela</b></td>
                                    <td>{trust.saidas}</td>

                                </tr>
                                <tr >
                                    <td><b>Tempo de saída da tela de prova</b></td>
                                    <td>{trust.tempo} segundos</td>

                                </tr>
                                <tr >
                                    <td><b>Vídeos sem rosto</b></td>
                                    <td>{parseFloat(trust.video_analyse.no_face).toFixed(2)}</td>

                                </tr>
                                <tr >
                                    <td><b>Múltiplas rostos</b></td>
                                    <td>{parseFloat(trust.video_analyse.multiple_faces_detected).toFixed(2)}</td>

                                </tr>
                                <tr >
                                    <td><b>Ips idênticos</b></td>
                                    <td>{trust.ip_equal}</td>

                                </tr>
                                <tr>
                                    <td><b>Pontos por métrica</b></td>
                                    <td>
                                        <div className="candidate-ai-points-options">
                                            {getTrustMetricRows().map(item => (
                                                <label key={item.key} className={item.selected ? "candidate-ai-points-item" : "candidate-ai-points-item disabled"}>
                                                    <input
                                                        type="checkbox"
                                                        checked={item.selected}
                                                        onChange={() => toggleTrustMetric(item.key)}
                                                    />
                                                    <span>{item.label}</span>
                                                    <small>Valor: {item.value} / {item.points.toFixed(2)} ponto(s)</small>
                                                </label>
                                            ))}
                                        </div>
                                    </td>
                                </tr>
                                <tr >
                                    <td><b>Eventos IA de vídeo</b></td>
                                    <td>{getVideoAIEventRows().length > 0 ? getSelectedAIEventsCount() : (trust.video_ai_events || 0)}</td>

                                </tr>
                                <tr >
                                    <td><b>Pontos IA de vídeo</b></td>
                                    <td>{getVideoAIEventRows().length > 0 ? getSelectedAIPoints().toFixed(2) : (trust.video_ai_points || 0)}</td>

                                </tr>
                                {getVideoAIEventRows().length > 0 && <tr>
                                    <td><b>Pontos IA detalhados</b></td>
                                    <td>
                                        <div className="candidate-ai-points-options">
                                            {getVideoAIEventRows().map(item => (
                                                <label key={item.eventType} className={item.selected ? "candidate-ai-points-item" : "candidate-ai-points-item disabled"}>
                                                    <input
                                                        type="checkbox"
                                                        checked={item.selected}
                                                        onChange={() => toggleAIEvent(item.eventType)}
                                                    />
                                                    <span>{item.label}</span>
                                                    <small>{item.total} evento(s) / {item.points.toFixed(2)} ponto(s)</small>
                                                </label>
                                            ))}
                                        </div>
                                    </td>
                                </tr>}
                                <tr >
                                    <td><b>Confiabilidade</b></td>
                                    <td>{getTrustMetricRows().length > 0 || getVideoAIEventRows().length > 0 ? getRecalculatedTrustPoints().toFixed(2) : parseFloat(trust_points).toFixed(2)}</td>

                                </tr>

                                </tbody>
                            </table>
                           
                        </div>
                    </div>}
                   

                   

                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
                    warning
                    title={"Atenção"}
                    onConfirm={() => {
                        setShowWarning(false);
                        setLoadingAllow(true);
                        AccessLiberation();

                        // setLoadingrelatorio(true);
                        // Deleterelatorio(relatorio_id);
                        // this.delete_banner(this.state.banner_to_delete);
                    }}
                    onCancel={() => {
                        setShowWarning(false);
                    }}
                    show={show_warning}
                    confirmBtnText='Sim, desejo liberar'
                    cancelBtnText='Cancelar'
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    showCancel={true}
                >
                    Ao liberar esse candidato, ele terá acesso a avaliação caso ele não tenha entrado durante o intervalo de horário determinado, ou caso ele já tenha finalizado a avaliação
                </SweetAlert>


            </div>

        </div>
    )
}

export default Relatorio;
